<template>
    <main class="container">
        <div class="card">
            <div class="card-body">
                <i class="fas fa-shopping-cart text-success" style="font-size: 10em;"></i>
                <i class="fas fa-check text-success " style="font-size: 10em;"></i>
                <h2>
                    Ευχαριστούμε πολύ!
                </h2>
                <span class="text"> Θα επικοινωνήσουμε σύντομα μαζί σας. </span>

            </div>
        </div>
        <div class="card">
            <div class="card-body text">
                Mπορείτε να κατεβάσετε μια επισκόπηση της παραγγελίας εδώ:
                <br>
                <a class="btn btn-outline-primary mt-2" :href="api+'/customer/pdf'+'?t='+encodeURIComponent(token)">
                    <i class="fas fa-download"></i>
                    Επισκόπηση Παραγγελίας
                </a>
            </div>
        </div>
        <div class="card">
            <div class="card-body text">
                Η επισκόπηση της παραγγελίας έχει σταλεί και στο email σας. Κοιτάξτε και στον φάκελο με τα junk/ανεπυθήμητα.
            </div>
        </div>
    </main>
</template>
<script>
    import StoreState from "../assets/StoreState";

    export default {
        name: "complete",
        data: () => ({
            token: StoreState.state.token,
            api: StoreState.state.api
        })
    }
</script>

<style scoped>
    .container {
        text-align: center;
    }

    .card .text {
        font-size: 1.3em;
    }

    .card {
        margin: 1em;
    }
</style>